$(function(){
	
	/*-------------------------------------------------
	高さ揃え
	----------------------------------------------- */
	$('.js_mheight').each(function(index, element) {
		$(element).matchHeight();
	});
	
	/*-------------------------------------------------
	objectFit
	----------------------------------------------- */
	objectFitImages();
	
	
	/*-------------------------------------------------
	ページ内リンク
	----------------------------------------------- */
	$('.com_page_link a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
	
	/*-------------------------------------------------
	商品一覧 ドロワー表示・非表示
	----------------------------------------------- */
	//ドロワー機能はShopifyのfiltering.jsを使用
	$('.sec_product .mobile-facets__open').click(function(){
		if(!$('.facets').hasClass('is-open')){
			$('.facets').addClass('is-open');
			$('.drawer-overlay').addClass('on');
		}
		
	});
	
	$('.sec_product .close_btn').click(function(){
		$('.facets').removeClass('is-open');
		$('.drawer-overlay').removeClass('on');
	});
	
	/*-------------------------------------------------
    下層ページローディング
    ----------------------------------------------- */
    var flg = false;
	
    var timer2 = setInterval(function(){
        if($('html').hasClass("wf-active")){
            flg = true;
            $('.load_mask').fadeOut();
            clearTimeout(timer2);
			
			$('.sec_mainv').addClass('js_active');
        }
    }, 300);
	
	/* メインビジュアル高さ（ios用）
	-------------------------------- */
	setMainHeight();
	$(window).resize(function(){
		setMainHeight();
	});
	function setMainHeight(){
		if($(window).width() < 767){
			//SP
			var wh = $(window).height();
		}

		$('.sec_mainv').css({
			'height': wh + 'px'
		});

	}
	
	/* ----------------------------------------
	 スクロールアニメーション
	---------------------------------------- */
	scrollAnimetion();
	$(window).on("resize scroll", function () {
		scrollAnimetion();
	});
	
	function scrollAnimetion(){
		
		var st = $(window).scrollTop();
		var wh = $(window).height();

		//fade表示
		$(".js_fadeup").each(function (i) {
			var tg = $(this).offset().top - wh * 0.9;
			if (st > tg) {
				$(this).addClass("scrollin");
			}
		});
	}
	
	/* ----------------------------------------
	 メインビジュアルスライド（トップ）
	---------------------------------------- */
	var mySwiper = new Swiper('.swiper-container.main_slide', {
		speed: 3000,
		slidePerView: '1',//スライド枚数
		loop: true,
		autoplay: {
		delay: 5000,//1枚目のスライダーの表示時間
		disableOnInteraction: false,
		},
      effect: 'fade',
	});
  
  mySwiper.on('slideChange', function () {// スライド切り替え時発火
	if (this.realIndex > 0) {// 1枚目以降の時
		this.params.autoplay.delay = 3000;// 2枚目以降の表示時間を指定
	}
});


    
	
});


/* ----------------------------------------
 パララックス
---------------------------------------- */
const image = document.getElementsByClassName('parallax');
new simpleParallax(image, {
	scale : 1.15,
    delay: 0.5,
});

//トップページ 商品
const img_product = document.getElementsByClassName('parallax_s');
new simpleParallax(img_product, {
	scale : 1.05,
    delay: 0.5,
});